module.exports = __webpack_public_path__ + "static/media/logo.993a1481.png";